export interface RegistrationRejectionReason {
  id: string;
  code: string;
  en: string;
  ar: string;
  sortOrder: number;
  activeState: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface FindRegistrationRejectionReasons {
  limit?: number;
  skip?: number;
  search?: string;
  activeState?: boolean;
}

export interface CreatePatchRegistrationRejectionReason {
  id?: string;
  en: string;
  ar: string;
  sortOrder?: number;
  activeState?: boolean;
}

export const initialState = {
  data: [] as RegistrationRejectionReason[],
  totalRecords: 0,
  limit: 25,
  skip: 0,
  currentPage: 0,
  status: 'idle' as 'idle' | 'pending' | 'succeeded' | 'failed',
  isLoading: false,
  isError: false,
  isSuccess: false,
};
